import { render, staticRenderFns } from "./CTIDialogSummaryTab.vue?vue&type=template&id=4d5a9215&scoped=true"
import script from "./CTIDialogSummaryTab.vue?vue&type=script&lang=js"
export * from "./CTIDialogSummaryTab.vue?vue&type=script&lang=js"
import style0 from "./CTIDialogSummaryTab.vue?vue&type=style&index=0&id=4d5a9215&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a9215",
  null
  
)

export default component.exports